<div class="pay-wrap">
  <!-- Botón oficial de Google Pay -->
  <div class="gpay-wrap" style="width: 100%">
    <google-pay-button
      id="google-pay-button"
      environment="PRODUCTION"
      buttonType="plain"
      buttonColor="black"
      buttonSizeMode="fill"
      buttonLocale="es"
      [buttonRadius]="100"
      [paymentRequest]="googlePaymentRequest"
      (loadpaymentdata)="onLoadPaymentData($event)"
      style="width: 100%; height: 40px; display: block;"
    ></google-pay-button>
  </div>

  <!-- Apple Pay -->
  <div class="apple-wrap" id="apple-pay-button-container">
    <!-- Apple Pay button injected via JS -->
  </div>
</div>
